import { Checkbox, Flex, Menu, Table, Tooltip } from '@mantine/core';
import React from 'react';
import EmptyIllustration from '../../../assets/icon/illustrations_no-document.svg';
import './styles.scss';
import { DataTableBodyProps } from '.';
import TableActionMenu from './TableActionMenu';
import SequenceAction from './SequenceAction';
import Sequence from './Sequence';

const TBody: React.FC<DataTableBodyProps> = ({
  columns,
  data,
  rawData,
  isNumbering,
  emptyMessage,
  emptyMessageTitle = 'No data available.',
  emptyMessageDescription = 'Click create button to add data here.',
  addText = 'Add',
  viewText = 'View Detail',
  deleteText = 'Delete',
  approvedText = 'Approved',
  rejectedText = 'Rejected',
  editText = 'Edit',
  downloadText = 'Download',
  activePage,
  activePageSize,
  theme,
  handleAdd,
  handleDelete,
  handleEdit,
  handleView,
  handleApproved,
  handleRejected,
  handleChangeSequence,
  handleDownload,
  handleCustomAction,
  handleCheckBox,
}) => {
  if (data.length === 0) {
    return (
      <Table.Tbody>
        <Table.Tr>
          <Table.Td
            colSpan={isNumbering ? columns.length + 1 : columns.length}
            style={{ textAlign: 'center' }}
          >
            {emptyMessage || (
              <div className="table-empty-message">
                <img
                  src={EmptyIllustration}
                  alt="empty-illustration"
                  width={200}
                />
                <div className="table-empty-message__text">
                  <h5 className="m-0" style={{ color: theme?.colors?.text }}>
                    {emptyMessageTitle}
                  </h5>
                  <p className="m-0" style={{ color: theme?.colors?.text }}>
                    {emptyMessageDescription}
                  </p>
                </div>
              </div>
            )}
          </Table.Td>
        </Table.Tr>
      </Table.Tbody>
    );
  }

  return (
    <Table.Tbody>
      {data.map((cell, index) => {
        const itemNumber =
          activePage !== 1
            ? (Number(activePage) - 1) * Number(activePageSize) + index + 1
            : index + 1;
        return (
          <Table.Tr key={index}>
            {isNumbering && (
              <Table.Td c={theme?.colors?.text}>{itemNumber}.</Table.Td>
            )}

            {columns.map((column, i) => {
              if (typeof column.props === 'function') {
                return (
                  <Table.Td key={i} c={theme?.colors?.text}>
                    {column.props(cell)}
                  </Table.Td>
                );
              }

              if(column.props === 'checklist-area' && handleCheckBox) {
                return (<Table.Td key={i}>
                  <Menu shadow="md">
                    <Flex justify={"center"}>
                      <Tooltip label="Select for Action">
                        <Checkbox
                          checked={data[index].isChecked}
                          disabled={data[index].disableCheck}
                          onChange={() => handleCheckBox(index)}
                        />
                      </Tooltip>
                    </Flex>
                  </Menu>
                </Table.Td>)
              }

              if (column.props === 'action') {
                return (
                  <Table.Td key={i}>
                    <TableActionMenu
                      data={cell}
                      addText={addText}
                      viewText={viewText}
                      editText={editText}
                      approvedText={approvedText}
                      rejectedText={rejectedText}
                      deleteText={deleteText}
                      downloadText={downloadText}
                      handleAdd={handleAdd}
                      handleDelete={handleDelete}
                      handleEdit={handleEdit}
                      handleView={handleView}
                      handleApproved={handleApproved}
                      handleRejected={handleRejected}
                      handleDownload={handleDownload}
                      handleCustomAction={handleCustomAction}
                    />
                  </Table.Td>
                );
              }

              if (column.props === 'sequence-rater') {
                return (
                  <Table.Td key={i}>
                    <SequenceAction
                      data={data}
                      rawData={rawData}
                      handleChangeSequence={handleChangeSequence}
                      index={index}
                      itemNumber={itemNumber}
                    />
                  </Table.Td>
                );
              }

              if (column.props === 'sequence') {
                return (
                  <Table.Td key={i}>
                    <Sequence
                      data={data}
                      rawData={rawData}
                      handleChangeSequence={handleChangeSequence}
                      index={index}
                      itemNumber={itemNumber}
                      headerProps={column.props}
                    />
                  </Table.Td>
                );
              }

              if (
                cell[column.props] === null ||
                cell[column.props] === '' ||
                cell[column.props] === undefined
              ) {
                return (
                  <Table.Td key={i} c={theme?.colors?.text}>
                    -
                  </Table.Td>
                );
              }

              return (
                <Table.Td key={i} c={theme?.colors?.text}>
                  {cell[column.props]}
                </Table.Td>
              );
            })}
          </Table.Tr>
        );
      })}
    </Table.Tbody>
  );
};

export default TBody;
